// extracted by mini-css-extract-plugin
export default {"dropzone":"DragAndDropUploader_dropzone__Ed5H1","active":"DragAndDropUploader_active__5Cz0m"};